import { forwardRef, type Ref, type SVGProps } from "react";

function SvgNfcPosterAnimated(
  props: SVGProps<SVGSVGElement> & { disableAnimations?: boolean },
  ref: Ref<SVGSVGElement>
) {
  const { disableAnimations = false, ...svgProps } = props;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={265}
      height={180}
      fill="none"
      {...svgProps}
    >
      <defs>
        <linearGradient
          id="NfcPoster_svg__a"
          x1={132.5}
          x2={132.5}
          y1={20}
          y2={153}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#B7DDFF" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>

      <path fill="#232836" d="M0 0h176v120H0z" />
      <path fill="#fff" d="M-437-2514H881v4236H-437z" />
      <rect
        width={829}
        height={3807}
        x={-344.5}
        y={-2471.5}
        stroke="#9747FF"
        strokeDasharray="10 5"
        rx={4.5}
      />

      <path
        fill="#fff"
        stroke="url(#NfcPoster_svg__a)"
        strokeLinecap="round"
        strokeWidth={13.125}
        d="M45 29.333A9.333 9.333 0 0 1 54.333 20h156.334A9.333 9.333 0 0 1 220 29.333v114.334a9.334 9.334 0 0 1-9.333 9.333H54.333A9.333 9.333 0 0 1 45 143.667z"
      />

      <path
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeWidth={2}
        d="M120.949 74.95c2.907 3.198 4.674 7.42 4.674 12.05 0 4.629-1.767 8.851-4.674 12.05"
        opacity="0.8"
      >
        {!disableAnimations && (
          <animate
            attributeName="opacity"
            values="0.3; 1; 0.3; 0.3; 1; 0.3"
            dur="2s"
            repeatCount="indefinite"
          />
        )}
      </path>

      <path
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeWidth={2}
        d="M129.369 67.685c4.215 4.939 6.754 11.31 6.754 18.265 0 6.954-2.539 13.326-6.754 18.265"
        opacity="0.6"
      >
        {!disableAnimations && (
          <animate
            attributeName="opacity"
            values="0.3; 0.3; 1; 0.3; 0.3; 1"
            dur="2s"
            repeatCount="indefinite"
          />
        )}
      </path>

      <path
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeWidth={2}
        d="M136.885 63.188c6.064 6.361 9.738 14.692 9.738 23.812s-3.674 17.45-9.738 23.812"
        opacity="0.4"
      >
        {!disableAnimations && (
          <animate
            attributeName="opacity"
            values="1; 0.3; 0.3; 1; 0.3; 0.3"
            dur="2s"
            repeatCount="indefinite"
          />
        )}
      </path>

      <g transform={disableAnimations ? "translate(0,0)" : undefined}>
        {!disableAnimations && (
          <animateTransform
            attributeName="transform"
            type="translate"
            values="0,0; -40,-40; 0,0"
            dur="3s"
            repeatCount="indefinite"
          />
        )}
        <path
          fill="#fff"
          stroke="#0C1C43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M161 114a9 9 0 0 1 9-9h18a9 9 0 0 1 9 9v42a9 9 0 0 1-9 9h-18a9 9 0 0 1-9-9z"
        />
        <circle
          cx={179}
          cy={156}
          r={3}
          fill="#fff"
          stroke="#0C1C43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
      </g>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgNfcPosterAnimated);
export default ForwardRef;
